module.exports = __webpack_public_path__ + "static/Flip Cup_x264-9cfcfbb32fcb811622bb04089f15bb8b.mp4";